import { render } from "./NumberWithMetricInput.vue?vue&type=template&id=c1afe038&scoped=true&lang=pug"
import script from "./NumberWithMetricInput.vue?vue&type=script&lang=ts"
export * from "./NumberWithMetricInput.vue?vue&type=script&lang=ts"

import "./NumberWithMetricInput.vue?vue&type=style&index=0&id=c1afe038&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c1afe038"

export default script